"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DOMElementType = exports.RefOf = exports.FocusPropTypes = exports.deprecated = exports.AlignTypes = exports.ShirtSizes = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ShirtSizes = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge"
};
exports.ShirtSizes = ShirtSizes;
ShirtSizes.DEFAULT = [ShirtSizes.SMALL, ShirtSizes.MEDIUM, ShirtSizes.LARGE];
ShirtSizes.LIMITED = [ShirtSizes.SMALL, ShirtSizes.MEDIUM];
ShirtSizes.ALL = (0, _values["default"])(ShirtSizes);
var AlignTypes = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
};
exports.AlignTypes = AlignTypes;
AlignTypes.ALL = (0, _values["default"])(AlignTypes);

var deprecated = function deprecated(name) {
  return function (props, propName, component) {
    if (props[propName] !== undefined) {
      return new Error("Deprecated prop '".concat(propName, "' supplied to ").concat(component, ". Use '").concat(name, "' instead."));
    }

    return null;
  };
};

exports.deprecated = deprecated;
var FocusPropTypes = {
  // properties copy from https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/src/Lock.js#L160
  // see description for props here: https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/interfaces.d.ts#L4
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  returnFocus: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
  noFocusGuards: _propTypes["default"].bool,
  allowTextSelection: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  persistentFocus: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  className: _propTypes["default"].string,
  whiteList: _propTypes["default"].func,
  shards: _propTypes["default"].arrayOf(_propTypes["default"].any),
  as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  lockProps: _propTypes["default"].object,
  onActivation: _propTypes["default"].func,
  onDeactivation: _propTypes["default"].func,
  sideCar: _propTypes["default"].any
};
exports.FocusPropTypes = FocusPropTypes;

var RefOf = function RefOf() {
  var propType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _propTypes["default"].object;
  return _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: propType
  })]);
};

exports.RefOf = RefOf;

var DOMElementType = _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Element), _propTypes["default"].instanceOf(window.ShadowRoot)]);

exports.DOMElementType = DOMElementType;
//# sourceMappingURL=customPropTypes.js.map